import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class CampaignUsersService {

    constructor(private apiHttp: ApiHttp) {
    }

    public getCompanyUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CampaignUsers/GetCompanyUsers', data, messageService);
    }

    public getSingleCompanyWallet(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CampaignUsers/GetSingleCompanyWallet', data, messageService);
    }

    public getCompanyTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CampaignUsers/GetCompanyTransactions', data, messageService);
    }

    public addOrRemoveUserToCampany(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CampaignUsers/AddOrRemoveUserToCampany', data, messageService);
    }
}
